// extracted by mini-css-extract-plugin
module.exports = {"blockquote":"CoreQuote_blockquote__IcTj9"};